import Button from "@bmi-digital/components/button";
import PromoSection from "@bmi-digital/components/promo-section";
import Typography from "@bmi-digital/components/typography";
import { Link } from "gatsby";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { getPathWithCountryCode } from "../utils/path";
import { GeneralErrorData } from "../templates/general-error";
import createImageProps from "./image/createImageProps";
import createVideoProps from "./video/createVideoProps";

const ErrorFallback = ({
  countryCode,
  generalError
}: {
  countryCode: string;
  generalError: GeneralErrorData;
}) => {
  const theme = useTheme();
  const { title, subtitle, featuredMedia, featuredVideo } = generalError;
  const cta = generalError.cta?.[0];
  const to: string | undefined =
    cta && getPathWithCountryCode(countryCode, cta.linkedPage.value.path);
  return (
    <PromoSection
      title={title}
      media={
        featuredVideo
          ? createVideoProps(featuredVideo, theme)
          : featuredMedia
            ? createImageProps(featuredMedia, theme)
            : undefined
      }
    >
      <Typography variant="body2" gutterBottom>
        {subtitle}
      </Typography>
      {cta && (
        <Button
          component={Link}
          to={to}
          gtm={{ id: "cta-click1", action: to, label: cta.label }}
        >
          {cta.label}
        </Button>
      )}
    </PromoSection>
  );
};

export default ErrorFallback;
